import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileExcel,
  faFilePdf,
  faEllipsisV,
} from "@fortawesome/free-solid-svg-icons";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import jsPDF from "jspdf";
import "jspdf-autotable";
import FilterContext from "../../routes/FilterContext";
import { connect } from "react-redux";
import { BodyAsFormData, downloadPdf } from "../../services/utilities/util";
import { apiMiddleware } from "../../services/apis/apiMiddleware";
import Table from "react-bootstrap/Table";
import InfiniteScroll from "react-infinite-scroll-component";
import { Link } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { JsonToExcel } from "react-json-to-excel";
import { convertJsonForExcel } from "../../services/utilities/util";
function mapStateToProps(state) {
  return {
    filters: state.selectedFilters,
    downloadOption: state.downloadOptions,
  };
}
export const BodyAsFormData1 = (page) => {
  var body = new FormData();
  body.append("page", page);
  return body;
};
class Custom1 extends React.Component {
  static contextType = FilterContext;
  state = {
    filters: {},
    recentyViewedTransactions: [Array.from({ length: 2 })],
    majorRecentTransactions: [Array.from({ length: 2 })],
    page: 1,
    page1: 1,
    isOpenErrorDisplayModal: false,
    jsonForExcelRecentAdded: [],
    jsonForExcelMajorRecent: [],
  };

  componentDidMount() {
    let body = new FormData();
    body.append("path", window.location.pathname);
    body.append("action", "visited");
    if (window.location.search.includes("?")) {
      body.append("hash", window.location.search.split("?").pop());
    } else {
      body.append("hash", "");
    }

    apiMiddleware
      .post(process.env.REACT_APP_USER_ACTIVITY, body)
      .then((res) => {
        console.log(res);
      });
    var filters;
    if (JSON.stringify(this.props.filters) == "{}") {
      filters = JSON.stringify(this.context.filters);
    } else {
      filters = JSON.stringify(this.props.filters);
    }
    this.state.filters = filters;
    apiMiddleware
      .post(
        "api/edge/office/get_custom_recently_added_transactions",
        BodyAsFormData1(this.state.page)
      )
      .then((res) => {
        let splicedData = res.data;
        this.setState({
          recentyViewedTransactions: splicedData,
          jsonForExcelRecentAdded: convertJsonForExcel(splicedData, {
            tenant: { name: "Occupier", type: "string" },
            execution_date: { name: "Date", type: "string" },
            complex: { name: "Asset", type: "string" },
            area: { name: "ChargeableArea (sqft)", type: "int" },
            rent: { name: "Rent (₹/sqft/month)", type: "int" },
            city: { name: "city", type: "string" },
          }),
        });
      });

    apiMiddleware
      .post(
        "api/edge/office/get_custom_major_recent_transactions",
        BodyAsFormData1(this.state.page1)
      )
      .then((res) => {
        let splicedDataMajor = res.data;
        this.setState({
          majorRecentTransactions: splicedDataMajor,
          jsonForExcelMajorRecent: convertJsonForExcel(splicedDataMajor, {
            tenant: { name: "Occupier", type: "string" },
            execution_date: { name: "Date", type: "string" },
            complex: { name: "Asset", type: "string" },
            area: { name: "ChargeableArea (sqft)", type: "int" },
            rent: { name: "Rent (₹/sqft/month)", type: "int" },
            city: { name: "city", type: "string" },
          }),
        });
      });
  }

  //   componentDidUpdate() {
  //     if (this.props.filters != this.state.filters){
  //       this.setState({ filters: this.props.filters });

  //       apiMiddleware
  //         .post(
  //           "api/edge/office/get_custom_recently_added_transactions",
  //           BodyAsFormData(JSON.stringify(this.props.filters))
  //         )
  //         .then((res) => {
  //           this.setState({
  //             recentyViewedTransactions: res.data,
  //           });
  //         });
  //     }
  //   }

  fetchMoreData = () => {
    this.setState({ page: this.state.page + 1 });
    setTimeout(() => {
      apiMiddleware
        .post(
          "api/edge/office/get_custom_recently_added_transactions",
          BodyAsFormData1(this.state.page)
        )
        .then((res) => {
          let recentViewed = this.state.recentyViewedTransactions.concat(
            res.data
          );
          this.setState({
            recentyViewedTransactions: recentViewed,
            jsonForExcelRecentAdded: convertJsonForExcel(recentViewed, {
              tenant: { name: "Occupier", type: "string" },
              execution_date: { name: "Date", type: "string" },
              complex: { name: "Asset", type: "string" },
              area: { name: "ChargeableArea (sqft)", type: "int" },
              rent: { name: "Rent (₹/sqft/month)", type: "int" },
              city: { name: "city", type: "string" },
            }),
          });
        });
    }, 1500);
  };

  fetchMajorTransactionData = () => {
    this.setState({ page1: this.state.page1 + 1 });
    setTimeout(() => {
      apiMiddleware
        .post(
          "api/edge/office/get_custom_major_recent_transactions",
          BodyAsFormData1(this.state.page1)
        )
        .then((res) => {
          let majorData = this.state.majorRecentTransactions.concat(res.data);
          this.setState({
            majorRecentTransactions: majorData,
            jsonForExcelMajorRecent: convertJsonForExcel(majorData, {
              tenant: { name: "Occupier", type: "string" },
              execution_date: { name: "Date", type: "string" },
              complex: { name: "Asset", type: "string" },
              area: { name: "ChargeableArea (sqft)", type: "int" },
              rent: { name: "Rent (₹/sqft/month)", type: "int" },
              city: { name: "city", type: "string" },
            }),
          });
        });
    }, 1500);
  };

  verifyUser(e) {
    if (this.props.downloadOption.edge_office_export === 0) {
      this.setState({ isOpenErrorDisplayModal: true });
      return false;
    }
  }

  closeErrorDisplayModal = () => {
    this.setState({ isOpenErrorDisplayModal: false });
  };

  render() {
    return (
      <div className="container-fluid developer mapsPage customPage p-0">
        <div className="row">
          <div className="col-lg-6">
            <div className="widget widgetTable">
              <div className="row">
                <div className="col-lg-9 text-start colorLightBlue widgetTableHeader">
                  <p>Recently Added Transactions</p>
                </div>
                <div className="col-lg-3 text-end">
                  <p className="colorBlack downloads">
                    <FontAwesomeIcon icon={faEllipsisV} />
                    <ul className="downloadOptions">
                      {/* <li className="excelDownload">
                        <ReactHTMLTableToExcel
                          id="RecentyAddedTransactionsTableXlsButton"
                          className="download-table-xls-button"
                          table="trecentyAddedTransactions"
                          filename="RecentyAddedTransactions"
                          sheet="RecentyAddedTransactions"
                          buttonText={"Download as Excel"}
                        />
                      </li> */}
                      {this.props.downloadOption.edge_office_export === 0 && (
                        <li
                          className="excelDownload"
                          onClick={(e) => {
                            this.verifyUser(e);
                          }}
                        >
                          Download as Excel
                        </li>
                      )}
                      {this.props.downloadOption.edge_office_export === 1 && (
                        <li className="excelDownload">
                          <JsonToExcel
                            title="Download as Excel"
                            data={this.state.jsonForExcelRecentAdded}
                            fileName="RecentyAddedTransactions"
                            btnClassName="download-table-xls-button"
                          />
                        </li>
                      )}
                      <li
                        className="pdfDownload"
                        onClick={(e) => {
                          downloadPdf(
                            "#recentyAddedTransactions",
                            "RecentyAddedTransactions"
                          );
                        }}
                      >
                        Download as PDF <FontAwesomeIcon icon={faFilePdf} />
                      </li>
                    </ul>
                  </p>
                </div>
                <div className="col-lg-12 mt-2">
                  <InfiniteScroll
                    dataLength={this.state.recentyViewedTransactions.length}
                    next={this.fetchMoreData}
                    hasMore={true}
                    height={400}
                    loader={<h4>Loading...</h4>}
                  >
                    <Table
                      responsive
                      hover
                      className="customRecentTransactions"
                      id="recentyAddedTransactions"
                    >
                      <tbody>
                        {this.state.recentyViewedTransactions.length > 0 &&
                          this.state.recentyViewedTransactions.map((row, i) => (
                            <tr className="">
                              <td>
                                <p>{row.execution_date}</p>
                                <h5>{row.complex}</h5>
                                <p>
                                  {row.micromarket}, {row.city}
                                </p>
                              </td>
                              <td>
                                <h5>{row.tenant}</h5>
                              </td>
                              <td>
                                <h5>{row.area} sq.ft.</h5>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </Table>
                  </InfiniteScroll>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="widget widgetTable">
              <div className="row">
                <div className="col-lg-9 text-start colorLightBlue widgetTableHeader">
                  <p>Major Recent Transactions</p>
                </div>
                <div className="col-lg-3 text-end">
                  <p className="colorBlack downloads">
                    <FontAwesomeIcon icon={faEllipsisV} />
                    <ul className="downloadOptions">
                      {/* <li className="excelDownload">
                        <ReactHTMLTableToExcel
                          id="MajorRecentTransactiontTableXlsButton"
                          className="download-table-xls-button"
                          table="majorRecentTransactiontable"
                          filename="TMajorRecentTransactiontable"
                          sheet="MajorRecentTransactiontable"
                          buttonText={"Download as Excel"}
                        />
                      </li> */}
                      {this.props.downloadOption.edge_office_export === 0 && (
                        <li
                          className="excelDownload"
                          onClick={(e) => {
                            this.verifyUser(e);
                          }}
                        >
                          Download as Excel
                        </li>
                      )}
                      {this.props.downloadOption.edge_office_export === 1 && (
                        <li className="excelDownload">
                          <JsonToExcel
                            title="Download as Excel"
                            data={this.state.jsonForExcelMajorRecent}
                            fileName="RecentyAddedTransactions"
                            btnClassName="download-table-xls-button"
                          />
                        </li>
                      )}
                      <li
                        className="pdfDownload"
                        onClick={(e) => {
                          downloadPdf(
                            "#majorRecentTransactiontable",
                            "MajorRecentTransactiontable"
                          );
                        }}
                      >
                        Download as PDF <FontAwesomeIcon icon={faFilePdf} />
                      </li>
                    </ul>
                  </p>
                </div>
                <div className="col-lg-12 mt-2">
                  <InfiniteScroll
                    dataLength={this.state.majorRecentTransactions.length}
                    next={this.fetchMajorTransactionData}
                    hasMore={true}
                    height={400}
                    loader={<h4>Loading...</h4>}
                  >
                    <Table
                      responsive
                      hover
                      className="customRecentTransactions"
                      id="majorRecentTransactiontable"
                    >
                      <tbody>
                        {this.state.majorRecentTransactions.length > 0 &&
                          this.state.majorRecentTransactions.map((row, i) => (
                            <tr className="">
                              <td>
                                <p>{row.execution_date}</p>
                                <h5>{row.complex}</h5>
                                <p>
                                  {row.micromarket}, {row.city}
                                </p>
                              </td>
                              <td>
                                <h5>{row.tenant}</h5>
                              </td>
                              <td>
                                <h5>{row.area} sq.ft.</h5>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </Table>
                  </InfiniteScroll>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-12 text-center">
            <Modal
              show={this.state.isOpenErrorDisplayModal}
              onHide={this.closeErrorDisplayModal}
              className="columnsModal timeModal notesModal"
              size="lg"
            >
              <Modal.Header closeButton>
                <Modal.Title>Notes</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="container">
                  <div className="row">
                    <div className="col-lg-12">
                      <p>
                        You do not have enough privileges to download data
                        Kindly contact{" "}
                        <a href="mailto:info@crematrix.com">
                          info@crematrix.com
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </Modal.Body>
            </Modal>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps)(Custom1);
